export function getSignalingUrl(peerId, roomId, host, admin)
{
	return `${process.env.REACT_APP_MEDIA_SERVER}/?peerId=${peerId}&roomId=${roomId}${host ? `&host=${host}` : ''}${admin ? `&admin=${admin}` : ''}`;
}